import { useQuery } from '@tanstack/react-query';
import * as ENDPOINTS from './endpoints';
import { useCustomMutation } from '../../hooks/useCustomMutation';

export const QUERY_KEYS = {
  teamComparisonMetrics: 'teamComparisonMetrics',
};

export const useSaveTeamComparisonMetricsMutation = () => {
  return useCustomMutation(
    [QUERY_KEYS.teamComparisonMetrics],
    ENDPOINTS.postTeamComparisonMetrics
  );
};
